import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-user-group-03-new',
  standalone: true,
  templateUrl: '../../assets/user-group-03-new.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamUserGroup03NewIcon {}
